import Vue from 'vue'
import { createHelpers } from 'vuex-map-fields'

import API, { HOMEPAGE_URL } from '@/lib/api'
import {
  // GET_REFERRER_INFORMATION
  GET_REFERRER_INFORMATION_REQUEST,
  GET_REFERRER_INFORMATION_SUCCESS,
  GET_REFERRER_INFORMATION_FAILURE,
} from '@/lib/mutationTypes'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

const { getReferrerFields, updateReferrerFields } = createHelpers({
  getterType: 'getReferrerFields',
  mutationType: 'updateReferrerFields',
})

const state = {
  data: {
    isHasReferrer: false,
    type: 'new',
    staffId: '',
    firstname: '',
    lastname: '',
    branchId: '',
  },
  update_refer: null,
  update_status: null,
  isUpdate: 0,
  validation: {
    rules: {
      staffId: 'required|min:5|numeric',
      firstname: 'required',
      lastname: 'required',
      branchId: 'required|numeric',
    },
    errors: null,
  },
  isLoading: false,
  isError: false,
}

const mutations = {
  // GET_REFERRER_INFORMATION
  [GET_REFERRER_INFORMATION_REQUEST]: state => {
    state.isLoading = true
    state.isError = false
  },
  [GET_REFERRER_INFORMATION_SUCCESS]: (state, payload) => {
    const {
      staffId,
      firstName: firstname,
      lastName: lastname,
      referrerBranchId: branchId,
    } = payload

    state.data = {
      ...state.data,
      staffId,
      firstname,
      lastname,
      branchId,
    }
    state.isLoading = false
    state.isError = false
  },
  [GET_REFERRER_INFORMATION_FAILURE]: state => {
    state.isLoading = false
    state.isError = true
  },
  UPDATE_REFER(state, payload) {
    state.update_refer = payload
  },
  UPDATE_STATUS_REFER(state, payload) {
    state.update_status = payload
  },
  SET_IS_UPDATE(state) {
    state.isUpdate += 1
  },
  updateReferrerFields,
}

const actions = {
  api_update_status({ commit }, data) {
    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'referrer-status/' + data.staffId,
        {
          referrerInfo: {
            isActive: data.isActive,
          },
        },
        {
          headers: {
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            commit('SET_IS_UPDATE')
            commit('UPDATE_STATUS_REFER', res.result)
            this._vm.$swal({
              type: 'success',
              title: 'บันทึกข้อมูลรหัสพนักงาน ' + data.staffId + ' เรียบร้อย',
              //html: '<h5>ขออภัย ข้อมูลของท่านไม่ตรงกับข้อกำหนดและเงื่อนไขของบริษัทประกันภัยไทยวิวัฒน์</h5>',
              showConfirmButton: true,
              allowOutsideClick: false,
              confirmButtonText: 'ok',
            })
          } else {
            commit('UPDATE_STATUS_REFER', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            commit('UPDATE_STATUS_REFER', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            })
          }
        },
      )
  },
  api_update_referrer({ commit }, data) {
    $('#modal-form-refer').modal('hide')
    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'referrer/' + data.staffId,
        {
          referrerInfo: {
            firstname: data.firstName,
            lastname: data.lastName,
            branchId: data.referrerBranchId,
          },
        },
        {
          headers: {
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            commit('SET_IS_UPDATE')
            this._vm.$swal({
              type: 'success',
              title: 'แก้ไขข้อมูลรหัสพนักงาน ' + data.staffId + ' เรียบร้อย',
              showConfirmButton: true,
              allowOutsideClick: false,
              confirmButtonText: 'ok',
            })
          } else {
            commit('UPDATE_REFER', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            commit('UPDATE_REFER', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            })
          }
        },
      )
  },
  getReferrerInformation({ commit }, data) {
    commit(GET_REFERRER_INFORMATION_REQUEST)

    Vue.http
      .get(API.REFERRAL.GET_REFERRER(data.staffId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        response => {
          const {
            result: { referrer },
          } = response

          commit(GET_REFERRER_INFORMATION_SUCCESS, referrer)
        },
        error => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return [
                commit(GET_REFERRER_INFORMATION_FAILURE),
                this._vm.$swal({
                  type: 'error',
                  title: 'ไม่พบข้อมูลพนักงาน',
                }),
              ]

            default:
              return [
                commit(GET_REFERRER_INFORMATION_FAILURE),
                this._vm.$swal({
                  type: 'error',
                  title: 'ไม่พบข้อมูลพนักงาน',
                }),
              ]
          }
        },
      )
  },
}

const getters = {
  getReferrerFields,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
